export default "__VITE_ASSET__858997ac__"